/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ what: NonNullable<unknown> }} Pc_Common_Screenshot_AltInputs */

const en_pc_common_screenshot_alt = /** @type {(inputs: Pc_Common_Screenshot_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft screenshot: ${i?.what}`)
};

const zh_pc_common_screenshot_alt = /** @type {(inputs: Pc_Common_Screenshot_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft 截图：${i?.what}`)
};

/**
* | output |
* | --- |
* | "PdfCraft screenshot: {what}" |
*
* @param {Pc_Common_Screenshot_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_common_screenshot_alt = /** @type {((inputs: Pc_Common_Screenshot_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Common_Screenshot_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_common_screenshot_alt(inputs)
	return zh_pc_common_screenshot_alt(inputs)
});
export { pc_common_screenshot_alt as "pc.common.screenshot_alt" }